import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import CandorLogoMark from './CandorLogoMark';

/**
 * Candor product lockup for AppBar and sidebar.
 * @param {{ compact?: boolean; showDivider?: boolean; logoSize?: number }} props
 */
const AppHeaderBrand = ({ compact = false, showDivider = false, logoSize = 40 }) => (
  <Stack direction="row" spacing={1.5} alignItems="center">
    {showDivider && (
      <Box
        sx={{
          width: '1px',
          height: 28,
          bgcolor: 'divider',
          display: { xs: 'none', md: 'block' },
          mr: 0.5,
        }}
      />
    )}
    <CandorLogoMark size={logoSize} />
    {!compact && (
      <Box sx={{ minWidth: 0 }}>
        <Typography
          component="span"
          sx={{
            display: 'block',
            fontWeight: 700,
            fontSize: '1.0625rem',
            lineHeight: 1.2,
            letterSpacing: '-0.025em',
            color: 'text.primary',
          }}
        >
          Candor
        </Typography>
        <Typography
          component="span"
          sx={{
            display: 'block',
            fontSize: '0.6875rem',
            fontWeight: 600,
            lineHeight: 1.3,
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            color: 'text.secondary',
          }}
        >
          Subscription Console
        </Typography>
      </Box>
    )}
  </Stack>
);

export default AppHeaderBrand;
